import { render, staticRenderFns } from "./RequirementCategory.vue?vue&type=template&id=9ec0b240"
import script from "./RequirementCategory.vue?vue&type=script&lang=js"
export * from "./RequirementCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports